// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3VHSo","select":"Header_select__2BsMm","clinic":"Header_clinic__2R6R3"};